import { RootEpic } from 'MyTypes';
import { from, of } from 'rxjs';
import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { isActionOf } from 'typesafe-actions';

import {
    ReiTypeEtiology,
    ReiTypeImpairment,
    ReiTypeInjury,
    ReiTypeRisk,
} from '@portal/common/models/rei-types';
import { applyLocationHierarchyWorkarounds } from '@portal/common/utility/location-helpers';

import config from '../../config';
import {
    getCausesAsync,
    getEtiologiesAsync,
    getImpairmentsAsync,
    getInjuryAsync,
    getLocationsAsync,
    getRisksAsync,
    getSequelasAsync,
} from './actions';

export const loadLocations: RootEpic = (action$, state$, dependencies) => {
    const { api } = dependencies;
    return action$.pipe(
        filter(isActionOf([getLocationsAsync.request])),
        switchMap((action) =>
            from(api.getLocations(undefined)).pipe(
                map((res) => {
                    const modifiedRes = res.map((location) =>
                        applyLocationHierarchyWorkarounds(location, {
                            chinaLocationId: config.chinaLocationId,
                            australiaLocationId: config.australiaLocationId,
                            newZealandLocationId: config.newZealandLocationId,
                            southeastAsiaEastAsiaAndOceaniaLocationId:
                                config.southeastAsiaEastAsiaAndOceaniaLocationId,
                            oceaniaLocationId: config.oceaniaLocationId,
                        })
                    );

                    return getLocationsAsync.success(modifiedRes);
                }),
                catchError((message: string) => of(getLocationsAsync.failure(message)))
            )
        )
    );
};

export const loadCauses: RootEpic = (action$, state$, dependencies) => {
    const { api } = dependencies;
    return action$.pipe(
        filter(isActionOf([getCausesAsync.request])),
        switchMap((action) =>
            from(api.data.getCauses()).pipe(
                map((res) => getCausesAsync.success(res)),
                catchError((message: string) => of(getCausesAsync.failure(message)))
            )
        )
    );
};

export const loadSequelas: RootEpic = (action$, state$, dependencies) => {
    const { api } = dependencies;
    return action$.pipe(
        filter(isActionOf([getSequelasAsync.request])),
        switchMap((action) =>
            from(api.data.getSequelas()).pipe(
                map((res) => getSequelasAsync.success(res)),
                catchError((message: string) => of(getSequelasAsync.failure(message)))
            )
        )
    );
};

export const loadRisks: RootEpic = (action$, state$, dependencies) => {
    const { api } = dependencies;
    return action$.pipe(
        filter(isActionOf([getRisksAsync.request])),
        switchMap((action) =>
            from(api.data.getRei(ReiTypeRisk)).pipe(
                map((res) => getRisksAsync.success(res)),
                catchError((message: string) => of(getRisksAsync.failure(message)))
            )
        )
    );
};

export const loadEtiology: RootEpic = (action$, state$, dependencies) => {
    const { api } = dependencies;
    return action$.pipe(
        filter(isActionOf([getEtiologiesAsync.request])),
        switchMap((action) =>
            from(api.data.getRei(ReiTypeEtiology)).pipe(
                map((res) => getEtiologiesAsync.success(res)),
                catchError((message: string) => of(getEtiologiesAsync.failure(message)))
            )
        )
    );
};

export const loadImpairment: RootEpic = (action$, state$, dependencies) => {
    const { api } = dependencies;
    return action$.pipe(
        filter(isActionOf([getImpairmentsAsync.request])),
        switchMap((action) =>
            from(api.data.getRei(ReiTypeImpairment)).pipe(
                map((res) => getImpairmentsAsync.success(res)),
                catchError((message: string) => of(getImpairmentsAsync.failure(message)))
            )
        )
    );
};

export const loadInjury: RootEpic = (action$, state$, dependencies) => {
    const { api } = dependencies;
    return action$.pipe(
        filter(isActionOf([getInjuryAsync.request])),
        switchMap((action) =>
            from(api.data.getRei(ReiTypeInjury)).pipe(
                map((res) => getInjuryAsync.success(res)),
                catchError((message: string) => of(getInjuryAsync.failure(message)))
            )
        )
    );
};
